import { render } from "./IdentitiesContent.vue?vue&type=template&id=1abd5e74&ts=true"
import script from "./IdentitiesContent.vue?vue&type=script&lang=ts"
export * from "./IdentitiesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__